import {useInfiniteQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getCopierList} from '../../../apis/copier/copier'

const PAGE_SIZE = 100

const useQueryCopierList = (id?: string) => {
    const {data, refetch, isLoading, isFetchingNextPage, fetchNextPage} = useInfiniteQuery({
        queryKey: QueryCacheKeys.copier.getCopierList(id),
        queryFn: async ({pageParam}) => {
            const {data} = await getCopierList(PAGE_SIZE, pageParam, id)
            return data
        },
        getNextPageParam: (lastPage, allPages) => {
            return allPages.length + 1
        },
    })

    const isEmpty = data?.pages?.at(0)?.length === 0
    const isReachingEnd = isEmpty || (data && data?.pages?.at(-1)?.length < PAGE_SIZE)

    return {data, refetch, isLoading, isFetchingNextPage, fetchNextPage, isReachingEnd}
}

export default useQueryCopierList
